import _ from 'lodash';
import { Toast } from 'primereact/toast';
import { useEffect, useRef, useState } from 'react';
import { errorToMsg } from '../../../Helper/ApiHelper/ErrorMessages';
import {
  AuthUserType,
  readAllServiceProvider
} from '../../../Helper/ApiHelper/LoginNetworkHelper';
import {
  EP,
  generateEpTreeFromPositions,
  readEpCatalogForPhase,
  removeAllHiddenCategoriesFromEpTree
} from '../../../Helper/ApiHelper/LvEpNetworkHelper';

import { DURATION_NOTIFICATION_ERROR_LONG } from '../../../Helper/Statics/Constants';
import BeeLoadingSpinner from '../../Atoms/BeeLoadingSpinner';
import { TimelineStep } from '../../Atoms/BeeTimeline';
import './AlphaAnalysisTabView.scss';
import {
  MiniKeyValEntry,
  readAllKeyValuesForPhaseByAlpha
} from '../../../Helper/ApiHelper/KeyValueNetworkHelper';
import AlphaTabPrincing from './AlphaTabPrincing';

type AlphaAnalysisTabViewProps = {
  phase: TimelineStep;
};

export default function AlphaAnalysisTabView({
  phase
}: AlphaAnalysisTabViewProps) {
  const [dataIsLoading, setDataIsLoading] = useState<boolean>(true);
  const [keyValLookup, setKeyValLookup] = useState();

  const [currentServiceProvider, setCurrentServiceProvider] = useState<
    AuthUserType[]
  >([]);
  const [currentEpTree, setCurrentEpTree] = useState<any>();
  const toast = useRef<Toast>(null);

  useEffect(() => {
    setDataIsLoading(true);

    const providerIds: string[] = phase.userIds ? phase.userIds : [];
    readAllServiceProvider()
      .then((userEntries: any) => {
        let prov = _.filter(userEntries, (entry) =>
          _.includes(providerIds, entry.id)
        );
        prov = _.sortBy(prov, ['organisation', 'username']);
        readEpCatalogForPhase(phase.id)
          .then((epData: any) => {
            const epLookup: any = setupEpLookup(epData);
            let currEpTree: any = generateEpTreeFromPositions(epData.data);
            currEpTree = currEpTree ? currEpTree : [];
            /*  currEpTree = removeAllHiddenCategoriesFromEpTree(currEpTree, false); */

            readAllKeyValuesForPhaseByAlpha(phase.id)
              .then((keyvals: any) => {
                let participatingProviderId: string[] = [];
                let valueLookup: any = new Map();
                if (keyvals && keyvals.length > 0) {
                  keyvals.forEach((kv: MiniKeyValEntry) => {
                    let entry = valueLookup.get(kv.key);
                    entry = entry ? entry : {};
                    entry[kv.organisationId] = kv.value;
                    valueLookup.set(kv.key, entry);
                    //create rejectedOffers

                    participatingProviderId.push(kv.organisationId);
                  });
                }
                //filter provider by rejection
                prov = _.filter(prov, (entry) =>
                  _.includes(participatingProviderId, entry.id)
                );

                setCurrentServiceProvider(prov);
                setCurrentEpTree(currEpTree);
                setDataIsLoading(false);
                setKeyValLookup(valueLookup);
              })
              .catch((error) => {
                if (toast.current) {
                  toast.current.show({
                    severity: 'error',
                    summary: error
                      ? errorToMsg(error)
                      : 'Laden der Dienstleisterdaten fehlgeschlagen',
                    detail:
                      'Beim Laden der Angebotsdaten der Dienstleister ist etwas schiefgelaufen. Bitte prüfen Sie Ihre Internetverbindung und versuchen Sie es erneut oder wenden Sie sich an den Kundenservice.',
                    sticky: true,
                    closable: true,
                    life: DURATION_NOTIFICATION_ERROR_LONG
                  });
                }
              });
          })
          .catch((error) => {
            if (toast.current) {
              toast.current.show({
                severity: 'error',
                summary: 'Laden des EP-Katalogs fehlgeschlagen',
                detail: error
                  ? errorToMsg(error)
                  : 'Beim Laden des hinterlegten EP-Katalogs ist etwas schiefgelaufen. Bitte prüfen Sie Ihre Internetverbindung und versuchen Sie es erneut oder wenden Sie sich an den Kundenservice.',
                sticky: true,
                closable: true,
                life: DURATION_NOTIFICATION_ERROR_LONG
              });
            }
          });
      })
      .catch((error) => {
        if (toast.current) {
          toast.current.show({
            severity: 'error',
            summary: 'Laden der Dienstleister fehlgeschlagen',
            detail: error
              ? errorToMsg(error)
              : 'Beim Laden der Dienstleister der Phase ist etwas schiefgelaufen. Bitte prüfen Sie Ihre Internetverbindung und versuchen Sie es erneut oder wenden Sie sich an den Kundenservice.',
            sticky: true,
            closable: true,
            life: DURATION_NOTIFICATION_ERROR_LONG
          });
        }
      });
  }, [phase]);

  ///////////////////////
  /////// HELPER ////////
  ///////////////////////

  function setupEpLookup(catalog: EP) {
    if (catalog && catalog.data) {
      const lookup = new Map();
      catalog.data.forEach((e) => {
        if (e.epCode) {
          lookup.set(e.epCode, e);
        }
      });
      return lookup;
    }
  }

  ///////////////////////
  /// VIEW COMPONENTS ///
  ///////////////////////

  function injectPayload() {
    if (dataIsLoading) {
      return (
        <div className={'bee-page-spinner'}>
          <BeeLoadingSpinner strokeWidth={'3'} type={'primary'} />
        </div>
      );
    }

    return (
      <AlphaTabPrincing
        phase={phase}
        serviceProvider={currentServiceProvider}
        keyValues={keyValLookup}
        epTree={currentEpTree}
      />
    );
  }

  return (
    <div className={'alpha-analysis-tab-view mt-6'}>
      {injectPayload()}
      <Toast ref={toast} position={'top-right'} />
    </div>
  );
}
